import { takeLatest, put, call } from "redux-saga/effects";
import * as types from "../../Action/actionTypes";
import api from "../../../Utils/api";
import { notifySuccess, notifyError, getWhiteLabelID } from "../../../Utils/Helper";
import { submitCorporateStepSuccess, submitCorporateStepFailure } from "../../Action/corporateSignup/corporateSignupActions";

function* submitCorporateStepSaga(action) {
  try {
    const { data, navigate } = action.payload;
    // Get whiteLabelID from localStorage
    const whiteLabelID = getWhiteLabelID();
    
    // Build URL with whiteLabelID query parameter
    const url = whiteLabelID 
      ? `/corporate-signup?whiteLabelID=${whiteLabelID}`
      : "/corporate-signup";
    
    const response = yield call(api.post, url, data);

    if (response?.data?.meta?.code === 200) {
      yield put(submitCorporateStepSuccess(response?.data?.data));
      notifySuccess(response?.data?.meta?.message || "Step saved successfully");
      
      // If navigate function is provided, call it
      if (navigate) {
        navigate();
      }
    } else {
        const message = response?.data?.meta?.message || "Something went wrong";
      yield put(submitCorporateStepFailure(message));
      notifyError(message);
    }
  } catch (error) {
    const message = error?.response?.data?.meta?.message || error?.message || "Something went wrong";
    yield put(submitCorporateStepFailure(message));
    notifyError(message);
  }
}

export default function* corporateSignupSaga() {
  yield takeLatest(types.SUBMIT_CORPORATE_STEP, submitCorporateStepSaga);
}
